// default navigation subnav
export function navigation(submenu) {
    if (('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0)) {
        window._farlo.helpers.getSiblings(submenu)[ 0 ].addEventListener('click', (e) => {
            if (!e.target.classList.contains('site-navigation__menu-item--active')) {
                e.preventDefault();

                e.currentTarget.classList.add('site-navigation__menu-item--active');
                submenu.classList.add('site-navigation__sub-menu--active');

                for (let i = 0; i < window._farlo.helpers.getSiblings(e.currentTarget.parentNode).length; i += 1) {
                    if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.contains('site-navigation__menu-item--active')) {
                        window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.remove('site-navigation__menu-item--active');
                    }

                    if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.contains('site-navigation__sub-menu--active')) {
                        window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.remove('site-navigation__sub-menu--active');
                    }
                }
            } else {
                return true;
            }
        });
    } else {
        submenu.parentNode.addEventListener('mouseover', () => {
            if (submenu.parentNode.querySelector('.site-navigation__sub-menu--active')) {
                submenu.parentNode.querySelectorAll('.site-navigation__sub-menu--active').forEach((_sel) => {
                    _sel.classList.remove('site-navigation__sub-menu--active');
                    _sel.parentNode.classList.remove('site-navigation__menu-item--active');
                });
            }
            submenu.classList.add('site-navigation__sub-menu--active');
            submenu.parentNode.classList.add('site-navigation__menu-item--active');
        });

        submenu.parentNode.addEventListener('mouseout', () => {
            submenu.classList.remove('site-navigation__sub-menu--active');
            submenu.parentNode.classList.remove('site-navigation__menu-item--active');
        });
    }
}